import React from 'react';
import classnames from 'classnames';

import * as styles from './content.module.scss';

const Content = ({ data }) => {
  return (
    <section>
      <article className={classnames(styles.article)}>{data}</article>
    </section>
  );
};

export default Content;
